import { Component, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";
import {
  CREATED_OPEN_TASKS,
  MY_OPEN_TASK,
  ALL_OPEN_TASKS,
  TasksTab,
} from "./tasks.service";

@Component({
    selector: "app-tasks",
    templateUrl: "./tasks.component.html",
    styleUrls: ["./tasks.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TasksComponent {
  constructor() {}
  myOpenTasks: TasksTab = MY_OPEN_TASK;
  createdOpenTasks: TasksTab = CREATED_OPEN_TASKS;
  allOpenTasks: TasksTab = ALL_OPEN_TASKS;
  columns: string[] = [];
  selectedFilters: { columnName: string; value: string }[] = [];

  app = getApp((app) => {
    this.app = app;
  });

  showShortDesciption = true;

  async ngOnInit() {
    await this.app.tasks.setTasksTab(MY_OPEN_TASK);
    await this.app.users.getAllUserNames();
  }

  alterDescriptionText() {
    this.showShortDesciption = !this.showShortDesciption;
  }

  getOptionText(field: string, value: string) {
    switch (field) {
      case "taskCompleted":
        if (value) {
          return this.app.field.getOptionText(
            this.app.fieldId.post.taskCompleted,
            "true",
          );
        } else {
          return this.app.field.getOptionText(
            this.app.fieldId.post.taskCompleted,
            "false",
          );
        }
      case "dinCodeRespOptions":
        return this.app.field.getOptionText(
          this.app.fieldId.post.dinCodeRespOptions,
          value,
        );
    }
  }
}
